import { createModel } from '@rematch/core';

import type { RootModel } from 'store/models';

export type StateType = {
  generatingByProfileId: Record<number, boolean>;
};

const initialState: StateType = {
  generatingByProfileId: {},
};

export const aiBattlecardGeneration = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setGenerating(
      state: StateType,
      { profileId, isGenerating }: { profileId: number; isGenerating: boolean },
    ) {
      return {
        ...state,
        generatingByProfileId: {
          ...state.generatingByProfileId,
          [profileId]: isGenerating,
        },
      };
    },
    clear(state: StateType, profileId: number) {
      const { [profileId]: _, ...rest } = state.generatingByProfileId;
      return {
        ...state,
        generatingByProfileId: rest,
      };
    },
  },
});
